import * as Yup from 'yup';

const Validation = Yup.object({
    name: Yup.string().required("Required"),
    // image: Yup.string().required("Required"),
    // status: Yup.string().required("Required"),
});

export default Validation;
